import { compose } from 'redux';
import { connect } from 'react-redux';
import RootStoreContext from '~/contexts/RootStoreContext';
import { selectors as commonSelectors } from '~/domains/common';
import { actions as modalActions } from '~/domains/modal';
import withLayoutContext from '~/components/LayoutContextProvider';
import { setModalType, registerModal } from '~/components/Modals';
import DeleteConfirmModal from './DeleteConfirmModal';

const mapStateToProps = (state) => ({
  // TODO: This feature will be implemented in the next sprint - W-20257302
  profile: commonSelectors.profile(state)
});

const mapDispatchToProps = (dispatch) => ({
  // TODO: This feature will be implemented in the next sprint - W-20257302
  onCancel: () => dispatch(modalActions.closeModal()),
  onConfirm: () => dispatch(modalActions.closeModal())
});

export default compose(
  registerModal,
  setModalType('DeleteConfirmModal'),
  withLayoutContext(),
  connect(mapStateToProps, mapDispatchToProps, null, {
    context: RootStoreContext
  })
)(DeleteConfirmModal);
